import React, { useState, useRef, useEffect } from "react";
import "./PassengerSelector.css";
import minus from "../../assets/images/packages/svg/minus.svg";
import plus from "../../assets/images/packages/svg/plus.svg";
import { useTranslation } from "../../contexts/TranslationContext";

const PassengerSelector = ({
  adults,
  children,
  infants,
  onAdultsChange,
  onChildrenChange,
  onInfantsChange,
  onClose,
}) => {
  const [open, setOpen] = useState(true);
  const containerRef = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setOpen(false);
        if (onClose) onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  if (!open) return null;

  // Functions to handle changes
  const handleAdultChange = (delta) => {
    const newValue = adults + delta;
    if (newValue >= 0) {
      onAdultsChange(newValue);
    }
  };

  const handleChildrenChange = (delta) => {
    const newValue = children + delta;
    if (newValue >= 0) {
      onChildrenChange(newValue);
    }
  };

  const handleInfantsChange = (delta) => {
    const newValue = infants + delta;
    if (newValue >= 0) {
      onInfantsChange(newValue);
    }
  };

  const handleClose = () => {
    setOpen(false);
    if (onClose) onClose();
  };

  return (
    <div className="traveler-container" ref={containerRef}>
      <div className="passenger-dropdown">
        <div className="mb-4">
          {/* Adults */}
          <div className="traveler-counter-container">
            <span className="traveler-name">{t("Adults")}</span>
            <div className="traveler-counter">
              <button
                type="button"
                className="traveler-counter-btn"
                onClick={() => handleAdultChange(-1)}
              >
                <img src={minus} alt="minus" />
              </button>
              <span>{adults}</span>
              <button
                type="button"
                className="traveler-counter-btn"
                onClick={() => handleAdultChange(1)}
              >
                <img src={plus} alt="plus" />
              </button>
            </div>
          </div>

          {/* Infants */}
          <div className="traveler-counter-container">
            <div className="traveler-name">
              <span>{t("Infants")}</span>
              <span className="traveler-name-desc">{t("LessThan")} 2</span>
            </div>
            <div className="traveler-counter">
              <button
                type="button"
                className="traveler-counter-btn"
                onClick={() => handleInfantsChange(-1)}
              >
                <img src={minus} alt="minus" />
              </button>
              <span>{infants}</span>
              <button
                type="button"
                className="traveler-counter-btn"
                onClick={() => handleInfantsChange(1)}
              >
                <img src={plus} alt="plus" />
              </button>
            </div>
          </div>

          {/* Children */}
          <div className="traveler-counter-container">
            <div className="traveler-name">
              <span>{t("Children")}</span>
              <span className="traveler-name-desc">
                {t("Ages")} 2 {t("To")} 12
              </span>
            </div>
            <div className="traveler-counter">
              <button
                type="button"
                className="traveler-counter-btn"
                onClick={() => handleChildrenChange(-1)}
              >
                <img src={minus} alt="minus" />
              </button>
              <span>{children}</span>
              <button
                type="button"
                className="traveler-counter-btn"
                onClick={() => handleChildrenChange(1)}
              >
                <img src={plus} alt="plus" />
              </button>
            </div>
          </div>
        </div>

        <button type="button" className="close-btn" onClick={handleClose}>
          {t("Done")}
        </button>
      </div>
    </div>
  );
};

export default PassengerSelector;
